import React, { useCallback, useMemo, useRef } from 'react';
import { Plugins } from '@capacitor/core';
const { Device } = Plugins;

export const usePlatform = () => {
    const [platform, setPlatform] = React.useState('');

    React.useEffect(() => {
        initPlatform();
    }, []);

    const initPlatform = async () => {
        const { platform } = await Device.getInfo();
        setPlatform(platform);
    };

    return platform;
};


export function useLongPress({
    onClick = (e: any) => {},
    onLongPress = (e: any) => {},
    ms = 300,
  } = {}) {
    const timerRef = useRef<any>(false);
    const eventRef = useRef<any>({});
  
    const callback = useCallback(() => {
      onLongPress(eventRef.current);
      eventRef.current = {};
      timerRef.current = false;
    }, [onLongPress]);
  
    const start = useCallback(
      (ev: any) => {
        ev.persist();
        eventRef.current = ev;
        timerRef.current = setTimeout(callback, ms);
      },
      [callback, ms]
    );
  
    const stop = useCallback(
      (ev: any) => {
        ev.persist();
        eventRef.current = ev;
        if (timerRef.current) {
          clearTimeout(timerRef.current);
          onClick(eventRef.current);
          timerRef.current = false;
          eventRef.current = {};
        }
      },
      [onClick]
    );
  
    return useMemo(
      () => ({
        onMouseDown: start,
        onMouseUp: stop,
        onMouseLeave: stop,
        onTouchStart: start,
        onTouchEnd: stop,
      }),
      [start, stop]
    );
  }

